import React, { useState } from 'react';
import { Button, Space, Input, Form, Select, Row, Col, Tag, Typography, notification } from 'antd';
import { PlusOutlined, SearchOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons';
import { TableCustom } from '../../../components/TableCustom';
import { useMutation, useQuery } from '@tanstack/react-query';
import { Link, useNavigate } from 'react-router-dom';
import { newObjectKeys } from '../../../utils/utility';
import { deletePartnerRequest, getListPartnersRequest } from '../../../services/onlinestore/partnerServiceRequest';
import { AppSelect } from '../../../constants/appSelect';

const { Text } = Typography;

const QuanLyDoiTac = () => {
  const navigate = useNavigate();
  const [formSearch] = Form.useForm();
  const [params, setParams] = useState({
    page: 1,
    limit: 20,
  });

  const {
    data: dataPartners,
    isPending,
    refetch: refetchDataPartners,
  } = useQuery({ queryKey: ['dataPartners', params], queryFn: () => getListPartnersRequest(params) });

  const { mutate: mutateDeletePartner } = useMutation({
    mutationFn: deletePartnerRequest,
    onSuccess: async (data) => {
      if (data?.status === 1) {
        notification.success({
          message: 'Xóa đối tác thành công!',
        });
        refetchDataPartners();
      } else {
        notification.error({
          message: data?.message || 'Có lỗi xảy ra vui lòng thử lại sau!',
        });
      }
    },
    onError: (error) => {
      notification.error({
        message: error.data?.message || 'Có lỗi xảy ra vui lòng thử lại sau!',
      });
    },
  });

  const handleSubmitForm = (values) => {
    const temp = { page: 1, limit: params.limit };
    if (values?.title) {
      Object.assign(temp, { title: values?.title });
    }
    if (values?.phone) {
      Object.assign(temp, { phone: values?.phone });
    }
    if (values?.email) {
      Object.assign(temp, { email: values?.email });
    }
    if (values?.status >= 0) {
      Object.assign(temp, { status: [values?.status] });
    }

    setParams(temp);
  };

  const columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
    },
    {
      title: 'Tên đối tác',
      dataIndex: ['id', 'title'],
      key: 'id',
      render: (_, { title, id }) => (
        <Link to={`/online-store/quan-ly-doi-tac/${id}/sua-doi-tac`} className="text-[#1677FF]">
          {title}
        </Link>
      ),
    },
    {
      title: 'Mô tả',
      dataIndex: 'description',
      key: 'description',
    },
    {
      title: 'Số điện thoại',
      dataIndex: 'phone',
      key: 'description',
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
    },
    {
      title: 'Địa chỉ',
      dataIndex: 'address',
      key: 'address',
    },
    {
      title: 'Trạng thái',
      dataIndex: 'status',
      key: 'status',
      render: (status) => (
        <Tag
          className="px-2 py-1 text-center"
          color={AppSelect.PARTNER_STATUS?.find((item) => item?.value === status)?.color}
        >
          {AppSelect.PARTNER_STATUS?.find((item) => item?.value === status)?.label}
        </Tag>
      ),
    },
    {
      title: 'Thời gian tạo',
      dataIndex: 'created_at',
      key: 'created_at',
      render: (_, { created_at }) => (
        <Space>{created_at && <Text className="text-[#667085]">{created_at}</Text>}</Space>
      ),
    },
    {
      title: 'Cập nhật lần cuối',
      dataIndex: ['updated_by', 'updated_at'],
      key: 'updated_at',
      render: (_, { updated_by, updated_at }) => (
        <Space direction="vertical">
          {updated_by && <Text className="text-[#667085]">{updated_by}</Text>}
          {updated_at && <Text className="text-[#667085]">{updated_at}</Text>}
        </Space>
      ),
    },
    {
      title: 'Thao tác',
      key: 'action',
      render: (_, record) => (
        <Space size={0}>
          <Button type="text" onClick={() => navigate(`/online-store/quan-ly-doi-tac/${record?.id}/sua-doi-tac`)}>
            <EditOutlined />
          </Button>
          <Button type="text" onClick={() => mutateDeletePartner({ id: record?.id })}>
            <DeleteOutlined />
          </Button>
        </Space>
      ),
    },
  ];

  return (
    <div className="m-5">
      <div className="flex justify-between items-center mb-5">
        <h1 className="text-2xl">Danh sách đối tác</h1>
        <Link to={'/online-store/quan-ly-doi-tac/them-doi-tac'}>
          <Button type="primary">
            <PlusOutlined />
            Thêm đối tác
          </Button>
        </Link>
      </div>

      <Form
        name="search_tags"
        form={formSearch}
        layout="vertical"
        requiredMark={false}
        className="mb-5"
        onFinish={handleSubmitForm}
      >
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12} md={8} xl={6}>
            <Form.Item name="title" label={<Text>Tên đối tác</Text>}>
              <Input placeholder="Nhập tên đối tác..." />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={8} xl={6}>
            <Form.Item name="phone" label={<Text>Số điện thoại</Text>}>
              <Input placeholder="Nhập số điện thoại..." />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={8} xl={6}>
            <Form.Item name="email" label={<Text>Email</Text>}>
              <Input placeholder="Nhập email..." />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={8} xl={6}>
            <Form.Item name="status" label={<Text>Trạng thái</Text>} initialValue={-1}>
              <Select
                showSearch
                filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                options={[{ value: -1, label: 'Tất cả' }, ...AppSelect.PARTNER_STATUS]}
              />
            </Form.Item>
          </Col>
          <Col className="flex items-center gap-2">
            <Button type="primary" htmlType="submit">
              <SearchOutlined />
              Tìm kiếm
            </Button>
            {params &&
              Object.values(newObjectKeys(params, ['title', 'phone', 'email', 'status'])).some((value) => value) && (
                <Button
                  htmlType="button"
                  onClick={() => {
                    formSearch.resetFields();
                    setParams({ page: 1, limit: params.limit });
                  }}
                >
                  <DeleteOutlined />
                  Xóa lọc
                </Button>
              )}
          </Col>
        </Row>
      </Form>

      <TableCustom
        columns={columns}
        dataSource={dataPartners?.data}
        totalItem={dataPartners?.total}
        params={params}
        setParams={setParams}
      />
    </div>
  );
};

export default QuanLyDoiTac;
